// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__21rxd","footer":"ModalInfo_footer__1N9Mv"};